<template>
  <!-- form-card: start -->
  <div class="circles-background">
    <img class="circle-1" :src="requireImg()" alt="circle" />
    <img class="circle-2" :src="requireImg()" alt="circle" />
    <img class="circle-3" :src="requireImg()" alt="circle" />
    <img class="circle-4" :src="requireImg()" alt="circle" />
  </div>
</template>

<script>
export default {
  props: {
    for: {
      type: String,
      validator(value) {
        return ["login", "layout"].indexOf(value) !== -1
      }
    }
  },
  methods: {
    requireImg() {
      return require(`@/assets/bubble-${this.for}.png`)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.circles-background {
  height: calc(100vh + 200px);
  width: 100vw;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;

  [class^="circle-"] {
    position: absolute;
    opacity: 1;
    z-index: 7;
    height: auto;
  }

  .circle-1 {
    width: 425px;
    top: -160px;
    left: -77px;
  }

  .circle-2 {
    height: 400px;
    top: 127px;
    right: -150px;
  }

  .circle-3 {
    height: 106px;
    left: 120px;
    top: 500px;
  }

  .circle-4 {
    height: 211px;
    right: 200px;
    top: 640px;
  }
}
</style>
